module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-up-right-f4dd501c.svg";